import { useRequiredParams } from '@pba/react-router';
import { LandingLayout } from 'layouts';
import { isMongoObjectId } from 'common/utils';
import { useUser } from 'features/auth';
import { PublicSharedEvent, PublicSharedProgramEvent } from 'features/events';
import { Footer, Header, type HeaderItem } from 'features/onboarding';
import type { OnboardingLocationState } from 'pages/types';
import { useOnboardingNavigation } from '../../hooks';
import { useNavigateToCalendar } from '../hooks';

const PagePublicSharedEvent = () => {
  const { eventId, invitationToken } = useRequiredParams<{ eventId: string; invitationToken: string }>();
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToPrimaryLogin } = useOnboardingNavigation<OnboardingLocationState>();
  const navigateToCalendar = useNavigateToCalendar();

  const headerButtons: HeaderItem[] = [];

  const user = useUser({ requiredAuth: false });

  if (user) {
    headerButtons.push({
      label: 'Go to Calendar',
      async onClick() {
        await navigateToCalendar();
      },
      type: 'primary',
    });
  } else {
    headerButtons.push({
      label: 'Log in',
      async onClick() {
        await onNavigateToPrimaryLogin({ referrer: window.location.pathname });
      },
      type: 'primary',
    });
  }

  return (
    <LandingLayout
      contentRight={
        isMongoObjectId(eventId) ? (
          <PublicSharedEvent eventId={eventId} invitationToken={invitationToken} />
        ) : (
          <PublicSharedProgramEvent eventId={eventId} invitationToken={invitationToken} />
        )
      }
      footer={<Footer />}
      header={<Header items={headerButtons} />}
      type="public-detail"
    />
  );
};

export default PagePublicSharedEvent;
